import { property } from "../data/property";
import Reveal from "./Reveal";
import {
  Sun,
  Flame,
  Wind,
  Trees,
  Home,
  Layers,
  Sparkles,
  Warehouse,
  MapPin
} from "lucide-react";

const ICONS = { Sun, Flame, Wind, Trees, Home, Layers, Sparkles, Warehouse, MapPin };

export default function Features() {
  return (
    <section
      id="kenmerken"
      data-testid="features-section"
      className="bg-brand-bg py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <Reveal className="max-w-3xl">
          <p className="overline">Kenmerken</p>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-brand-ink sm:text-5xl lg:text-6xl text-balance">
            Comfort en duurzaamheid <span className="italic">verfijnd</span> samengebracht.
          </h2>
          <p className="mt-6 max-w-xl text-lg text-brand-muted">
            Met diverse moderniseringen en duurzame upgrades is dit huis klaar voor jarenlang woonplezier.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px bg-brand-border sm:grid-cols-2 lg:grid-cols-3">
          {property.features.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <Reveal
                key={f.title}
                testId={`feature-${i}`}
                delay={(i % 3) * 0.06}
                y={20}
                amount={0.15}
                className="group relative bg-brand-bg p-8 transition-colors duration-300 hover:bg-brand-surface md:p-10"
              >
                <div className="flex h-12 w-12 items-center justify-center border border-brand-border text-brand-moss transition-all group-hover:bg-brand-moss group-hover:text-white">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-brand-ink">{f.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-muted">{f.desc}</p>
              </Reveal>
            );
          })}
        </div>

        {/* Specs table */}
        <div className="mt-20 grid grid-cols-1 gap-12 border-t border-brand-border pt-12 md:grid-cols-3">
          <div>
            <p className="overline">Oppervlakten</p>
            <ul className="mt-6 space-y-3 text-sm">
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Wonen</span>
                <span className="text-brand-ink">137 m²</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Perceel</span>
                <span className="text-brand-ink">265 m²</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Inhoud</span>
                <span className="text-brand-ink">536 m³</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Buitenruimte</span>
                <span className="text-brand-ink">4 m²</span>
              </li>
            </ul>
          </div>
          <div>
            <p className="overline">Indeling</p>
            <ul className="mt-6 space-y-3 text-sm">
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Kamers</span>
                <span className="text-brand-ink">5 (4 slaapkamers)</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Badkamers</span>
                <span className="text-brand-ink">1 + 2 toiletten</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Woonlagen</span>
                <span className="text-brand-ink">3</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Voorzieningen</span>
                <span className="text-right text-brand-ink">Airco, zonwering, mech. ventilatie</span>
              </li>
            </ul>
          </div>
          <div>
            <p className="overline">Energie & Tuin</p>
            <ul className="mt-6 space-y-3 text-sm">
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Verwarming</span>
                <span className="text-brand-ink">Hybride warmtepomp</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Isolatie</span>
                <span className="text-right text-brand-ink">Dak, muur, vloer, HR-glas</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Achtertuin</span>
                <span className="text-brand-ink">81 m² (zuid)</span>
              </li>
              <li className="flex justify-between border-b border-brand-border pb-3">
                <span className="text-brand-muted">Garage</span>
                <span className="text-brand-ink">1 auto · aangebouwd</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
